/**
 * v2.56 — PriceCsvDropzone
 * Simple CSV file input with drag-over highlight.
 */
import { useRef, useState } from 'react';

interface Props {
  onFile: (file: File) => void;
}

export default function PriceCsvDropzone({ onFile }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const f = e.target.files?.[0];
    if (f) onFile(f);
  }

  function handleDrop(e: React.DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragging(false);
    const f = e.dataTransfer.files?.[0];
    if (f) {
      onFile(f);
      // sync the input element so the file name shows
      if (inputRef.current) {
        const dt = new DataTransfer();
        dt.items.add(f);
        inputRef.current.files = dt.files;
      }
    }
  }

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={handleDrop}
      style={{
        border: `2px dashed ${dragging ? '#6366f1' : '#d1d5db'}`,
        borderRadius: 8,
        padding: '1.5rem',
        textAlign: 'center',
        cursor: 'pointer',
        background: dragging ? '#eef2ff' : 'transparent',
        transition: 'background 0.15s, border-color 0.15s',
      }}
      onClick={() => inputRef.current?.click()}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && inputRef.current?.click()}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".csv"
        data-testid="price-file"
        style={{ display: 'none' }}
        onChange={handleChange}
      />
      <p style={{ margin: 0, color: '#6b7280', fontSize: '0.875rem' }}>
        Arrastra un CSV aquí o <span style={{ color: '#6366f1', textDecoration: 'underline' }}>selecciona archivo</span>
      </p>
    </div>
  );
}
